import { createContext, useContext } from "react";

export const ConfirmContext = createContext();

export function useConfirmContext() {
  return useContext(ConfirmContext);
}
